import { SidebarRoute } from "./SidebarRoute";
import { Disclosure } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import { XIcon } from "@heroicons/react/outline";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export function SIDEBAR({ sethidesideBar }) {
  return (
    <div className="flex flex-col flex-grow border-r border-gray-200 pt-5 pb-4 bg-white overflow-y-auto">
      <div className="flex items-center flex-shrink-0 px-4">
        <img
          className="h-12 w-3/4"
          src={process.env.REACT_APP_LOGO_SIDEBAR}
          alt={process.env.REACT_APP_APPS_NAME}
        />
        <button
          onClick={() => sethidesideBar(true)}
          className="flex items-center justify-end w-1/4"
        >
          <XIcon className="h-6 w-6" color="gray" aria-hidden="true" />
        </button>
      </div>
      <div className="mt-5 flex-grow flex flex-col">
        <nav className="flex-1 px-2 bg-white space-y-1">
          {SidebarRoute.map((item) =>
            !item.children ? (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) =>
                  classNames(
                    isActive
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-900 hover:bg-gray-50",
                    "group w-full flex items-center pl-2 py-2 text-sm font-semibold rounded-md"
                  )
                }
              >
                <item.icon
                  className="text-gray-400 mr-3 flex-shrink-0 h-6 w-6"
                  aria-hidden="true"
                />
                {item.name}
              </NavLink>
            ) : (
              <Disclosure as="div" key={item.name} className="space-y-1">
                {({ open }) => (
                  <>
                    <Disclosure.Button
                      className={classNames(
                        item.current
                          ? "bg-gray-100 text-gray-900"
                          : "text-gray-900",
                        "group w-full flex items-center pl-2 pr-1 py-2 text-left text-sm font-semibold rounded-md"
                      )}
                    >
                      <item.icon
                        className="text-gray-400 mr-3 flex-shrink-0 h-6 w-6"
                        aria-hidden="true"
                      />
                      <span className="flex-1">{item.name}</span>
                      <svg
                        className={classNames(
                          open ? "text-gray-900 rotate-90" : "text-gray-900",
                          "ml-3 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-900 transition-colors ease-in-out duration-150"
                        )}
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                      >
                        <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
                      </svg>
                    </Disclosure.Button>
                    <Disclosure.Panel className="space-y-1">
                      {item.children.map((subItem) => (
                        <NavLink
                          key={subItem.name}
                          to={subItem.href}
                          className={({ isActive }) =>
                            classNames(
                              isActive
                                ? "bg-gray-100 text-gray-900"
                                : "text-gray-900 hover:bg-gray-50",
                              "group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium rounded-md"
                            )
                          }
                        >
                          {subItem.name}
                        </NavLink>
                      ))}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            )
          )}
        </nav>
      </div>
    </div>
  );
}
